import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fab-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!

  return (!_ctx.hideTabNavigation)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["tab-bar", { android: _ctx.isAndroid }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "fab-button",
            onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/menu'))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "order-button" }, "ORDER", -1)
          ]))
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["tab-button", { active: _ctx.isActiveRoute('/') }]),
          onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/'))
        }, [
          _createVNode(_component_ion_icon, {
            icon: _ctx.isActiveRoute('/') ? _ctx.home : _ctx.homeOutline,
            class: "nav-color"
          }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, { class: "nav-color" }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("HOME")
            ])),
            _: 1,
            __: [6]
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab-button", { active: _ctx.isActiveRoute('/deals') }]),
          onClick: _cache[2] || (_cache[2] = () => _ctx.router.push('/deals'))
        }, [
          _createVNode(_component_ion_icon, {
            icon: _ctx.isActiveRoute('/deals') ? _ctx.pricetags : _ctx.pricetagsOutline,
            class: "nav-color"
          }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, { class: "nav-color" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("DEALS")
            ])),
            _: 1,
            __: [7]
          })
        ], 2),
        _cache[10] || (_cache[10] = _createElementVNode("svg", null, null, -1)),
        _createElementVNode("button", {
          class: _normalizeClass(["tab-button", { active: _ctx.isActiveRoute('/rewards') }]),
          onClick: _cache[3] || (_cache[3] = () => _ctx.router.push('/rewards'))
        }, [
          _createVNode(_component_ion_icon, {
            icon: _ctx.isActiveRoute('/rewards') ? _ctx.star : _ctx.starOutline,
            class: "nav-color"
          }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, { class: "nav-color" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("REWARDS")
            ])),
            _: 1,
            __: [8]
          })
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab-button", { active: _ctx.isActiveRoute('/login') }]),
          onClick: _cache[4] || (_cache[4] = () => (_ctx.isLoggedIn ? _ctx.router.push('/account') : _ctx.router.push('/login')))
        }, [
          _createVNode(_component_ion_icon, {
            icon: _ctx.isActiveRoute('/login') ? _ctx.person : _ctx.personOutline,
            class: "nav-color"
          }, null, 8, ["icon"]),
          _createVNode(_component_ion_label, { class: "nav-color" }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("ACCOUNT")
            ])),
            _: 1,
            __: [9]
          })
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}